import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './profile/profile.component';
import { ListComponent } from './list/list.component';
import { HeirarchyComponent } from './heirarchy/heirarchy.component';
import { TeamListingComponent } from './team-listing/team-listing.component';
// import { TeamComponent } from './team/team.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { SupplierListComponent } from './supplier-list/supplier-list.component';
import { ValidationComponent } from './validation/validation.component';
import { UpdateComponent , ImageCropDialogComponent  } from './update/update.component';
import { InnerHeirarchyComponent } from './inner-heirarchy/inner-heirarchy.component';
import { AddPopupComponent} from './Popups/add-popup/add-popup.component';
import { UpdatePopupComponent} from './Popups/update-popup/update-popup.component';
import { DeletePopupComponent} from './Popups/delete-popup/delete-popup.component';
import { SharedModule } from '../shared/shared.module';
import { SiteProfileComponent } from './site-profile/site-profile.component';
import { SiteListComponent } from './site-list/site-list.component';
import { SiteNewComponent } from './site-new/site-new.component';
import { OrganizationResolver } from './profile/organization.resolver';
import { SiteResolver } from './site-profile/site.resolver';
import { AgmCoreModule } from '@agm/core';
import { TextMaskModule } from 'angular2-text-mask';

import {
  MatSnackBarContainer,
  MatSnackBar,
  MatAutocompleteModule,
  MatToolbarModule,
  MatCardModule,
  MatInputModule,
  MatButtonModule,
  MatSidenavModule,
  MatSelectModule,
  MatDialogModule,
  MatDatepickerModule,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  MatPaginatorModule,
  MatSortModule,
  MatTooltipModule,
} from '@angular/material';
// import {}
import { TeamListComponent } from './team-list/team-list.component';
import { TeamUnassignedAssociatesComponent } from './team-unassigned-associates/team-unassigned-associates.component';
import { TeamProfileComponent } from './team-profile/team-profile.component';
import { NewTeamComponent } from './new-team/new-team.component';
import { TeamResolver } from './team-profile/team.resolver';
import { AssignTeamComponent } from './Popups/assign-team/assign-team.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AuthGuard } from '../shared/services/auth/auth.guard';
import { AddJobPositionComponent } from './Popups/add-job-position/add-job-position.component';
import { ChangeOrganizationParentComponent } from './Popups/change-organization-parent/change-organization-parent.component';
import { ImageCropperModule } from 'ngx-image-cropper';

// import { GraphHeirarchyComponent } from './graph-heirarchy/graph-heirarchy.component';
// import { NgOrganizationChartModule} from 'ng-organization-chart/src/ng-organization-chart/ng-organization-chart.module';
// import { OrgChartModule } from 'ng-org-chart';
// import { GraphInnerHeirarchyComponent } from './graph-inner-heirarchy/graph-inner-heirarchy.component';

// // internationalization
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CompanyHierarchyComponent } from './company-hierarchy/company-hierarchy.component';
import { ManagementHierarchyComponent } from './management-hierarchy/management-hierarchy.component';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const routes: Routes = [
    {
        path: 'home/organization',
        redirectTo: 'home/organization/organization-list',
        pathMatch: 'full'
    }, {
        path: 'profile/:action/:id/:tab',
        pathMatch:'full',
        component: ProfileComponent,
        resolve: { organization: OrganizationResolver},
        canActivate: [AuthGuard]
    }, {
        path: 'profile/:action/:id',
        pathMatch:'full',
        component: ProfileComponent,
        resolve: { organization: OrganizationResolver},
        canActivate: [AuthGuard]
    }, {
        path: 'validation/:org-id',
        component: ValidationComponent
    }, {
        path: 'inner-heirarchy/:id',
        component: InnerHeirarchyComponent,
        resolve: {organization: OrganizationResolver }
    }, {
        path: 'new',
        component: UpdateComponent
    }, {
        path: 'organization-list',
        component: ListComponent
    }, {
        path: 'heirarchy',
        component: HeirarchyComponent
    }, 
    // {
    //     path: 'team/:team-id',
    //     component: TeamComponent
    // },
     {
        path: 'new-site/:organization_id',
        component: SiteNewComponent
    }, {
        path: 'site-list/:role/:organization_id',
        component: SiteListComponent
    }, {
        path: 'site-profile/:action/:id',
        component: SiteProfileComponent ,
        resolve: { site : SiteResolver }
    }, {
        path: 'team-list/:role/:organization_id',
        component: TeamListComponent
    }, {
        path: 'team-unassigned-associates/:organization_id',
        component: TeamUnassignedAssociatesComponent
    }, {
        path: 'team-profile/:action/:id/:organization_id',
        component: TeamProfileComponent,
        resolve: { organization: TeamResolver }
    },
    {
        path: 'team-new/:organization_id',
        component: NewTeamComponent
    },
    {
        path: 'new-supplier',
        component: SupplierListComponent
    }
    // { path: 'heirarchy-graph', component: GraphHeirarchyComponent },
    // { path: 'inner-heirarchy-graph', component: GraphInnerHeirarchyComponent }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    SharedModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    NgxPaginationModule,
    MatPaginatorModule,
    ImageCropperModule,
    MatTooltipModule,
    MatSortModule,
    MatProgressSpinnerModule,
    TextMaskModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDMk_knEVp1-lPGaTEO-tc9rTy6fqsVGlk'
    }),
    TranslateModule.forChild({
        loader: {
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [HttpClient]
        }
    }),
  ],
  entryComponents: [ AddPopupComponent, UpdatePopupComponent , DeletePopupComponent, AssignTeamComponent, AddJobPositionComponent,
                 ChangeOrganizationParentComponent, ImageCropDialogComponent ],
  declarations: [AddPopupComponent , UpdatePopupComponent , DeletePopupComponent , InnerHeirarchyComponent,
                ProfileComponent, ListComponent, HeirarchyComponent, TeamListingComponent,
                CustomerListComponent, SupplierListComponent, ValidationComponent, UpdateComponent,
                 SiteProfileComponent, SiteListComponent, SiteNewComponent, TeamListComponent,
                  TeamUnassignedAssociatesComponent, TeamProfileComponent, NewTeamComponent, AssignTeamComponent,
                AddJobPositionComponent, ImageCropDialogComponent ,
                ChangeOrganizationParentComponent,
                CompanyHierarchyComponent,
                ManagementHierarchyComponent ],
  providers: [ OrganizationResolver, SiteResolver, TeamResolver, MatSnackBar ]
})
export class OrganizationModule { }

